var EmailFormNumberInputView, EmailFormTextInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require("../../common/views/text_input_view");

EmailFormNumberInputView = (function(superClass) {
  extend(EmailFormNumberInputView, superClass);

  function EmailFormNumberInputView() {
    return EmailFormNumberInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormNumberInputView.prototype.tagName = 'li';

  EmailFormNumberInputView.prototype.events = {
    'keyup .number_input': 'validateEmailForm'
  };

  EmailFormNumberInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".number_input";
    return this.template = {
      number_input_template: true
    };
  };

  return EmailFormNumberInputView;

})(EmailFormTextInputView);

module.exports = EmailFormNumberInputView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9jb21tb24vbnVtYmVyX2lucHV0X3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9jb21tb24vbnVtYmVyX2lucHV0X3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsZ0RBQUE7RUFBQTs7O0FBQUEsc0JBQUEsR0FBeUIsT0FBQSxDQUFRLG9DQUFSOztBQUVuQjs7Ozs7OztxQ0FDSixPQUFBLEdBQVM7O3FDQUVULE1BQUEsR0FDRTtJQUFBLHFCQUFBLEVBQXVCLG1CQUF2Qjs7O3FDQUVGLFVBQUEsR0FBWSxTQUFBO0lBQ1Ysc0JBQXNCLENBQUEsU0FBRSxDQUFBLFVBQVUsQ0FBQyxLQUFuQyxDQUF5QyxJQUF6QyxFQUErQyxTQUEvQztJQUNBLElBQUMsQ0FBQSxTQUFELEdBQWE7V0FDYixJQUFDLENBQUEsUUFBRCxHQUFZO01BQUMscUJBQUEsRUFBdUIsSUFBeEI7O0VBSEY7Ozs7R0FOeUI7O0FBV3ZDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
